import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TranslationCoreModule } from '@qtek/libs/translation-core';
import { Message } from '@qtek/shared/models';

export interface ConfirmDialogInput {
  /** Translation code for title.  */
  title?: string;

  /** Message to be displayed below the title. */
  message: Message;

  /** Addiditonal Message to be displayed below the message. */
  additionalMessage?: Message;

  /** Translation code for accept button. Only works if there are no options. */
  acceptButton?: string;

  /** Translations code for cancel button. */
  cancelButton?: string;

  /**
   * If dialog should allow to accept one of many values, pass translation codes for each option here.
   * Selecting option will emit its index.
   */
  options?: string[];

  /** Whether to highlight the title (e.g., in red color). */
  highlightTitle?: boolean;

  /** Width of the dialog */
  width?: string;
}

export const confirmDialogConfig: MatDialogConfig = {
  autoFocus: false,
};

@Component({
  selector: 'qt-confirm-dialog',
  templateUrl: 'confirm-dialog.component.html',
  styleUrls: ['confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    TranslationCoreModule,
    FlexLayoutModule,
    MatButtonModule,
  ],
})
export class ConfirmDialogComponent {
  data = inject<ConfirmDialogInput>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);

  constructor() {
    this.data = {
      acceptButton: 'GNR_OK',
      cancelButton: 'GNR_CANCEL',
      ...this.data,
    };

    // Update dialog width if provided
    if (this.data.width) {
      this.dialogRef.updateSize(this.data.width);
    }
  }
}
